var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.56,
    height: 23.044,
    viewBox: "0 0 32.56 23.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Management",
    "data-name": "Vehicle Management",
    transform: "translate(0 -5.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10986",
    "data-name": "Group 10986",
    transform: "translate(0 5.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12703",
    "data-name": "Path 12703",
    d: "M32.373,12.838a.837.837,0,0,0-.646-.308H28.558c-.782-2.063-1.8-4.083-2.959-4.846-4.006-2.635-14.631-2.635-18.637,0C5.8,8.447,4.789,10.471,4,12.53H.834a.834.834,0,0,0-.816,1l.469,2.274a.833.833,0,0,0,.816.664h.939A5.629,5.629,0,0,0,.89,20.151a5.511,5.511,0,0,0,1.742,4.138c.013.011.025.018.037.029V27.5a1.252,1.252,0,0,0,1.251,1.251H6.842A1.252,1.252,0,0,0,8.093,27.5V26.221H24.467V27.5a1.252,1.252,0,0,0,1.251,1.251H28.64A1.253,1.253,0,0,0,29.891,27.5v-3.12a5.72,5.72,0,0,0,.365-7.911h1a.831.831,0,0,0,.816-.665l.47-2.273A.84.84,0,0,0,32.373,12.838ZM8.335,9.772c3.193-2.1,12.7-2.1,15.888,0,.62.407,1.418,2.052,2.149,4.066H6.188C6.917,11.825,7.715,10.181,8.335,9.772ZM4.6,20.464a2.46,2.46,0,1,1,2.46,2.46A2.46,2.46,0,0,1,4.6,20.464Zm20.941,2.46A2.46,2.46,0,1,1,28,20.464,2.461,2.461,0,0,1,25.537,22.924Z",
    transform: "translate(0 -5.707)",
    fill: "#88eada"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleManagement);
export default __webpack_public_path__ + "static/media/Vehicle Management.9cf8d4a310d79cf4bbe44d9f5ebcd7d7.svg";
export { ForwardRef as ReactComponent };